import React, { Fragment, useState, useEffect } from "react";
import { Card, Form, Spinner, Button } from "react-bootstrap";
import {  useLocation, useParams } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";


const SoldTicket = () => {
  const location = useLocation();
  const { getRequest } = useRequests();

  const [usersTickets, setUsersTickets] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

 

  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [loading, setLoading] = useState(true);

  const fetchResaleTickets = async () => {
    const response = await getRequest(`resale-tickets`); // Replace "users" with the appropriate API endpoint
    if (response && response.code === 200) {
      const filteredTickets = response.data.filter(ticket => ticket.resale_status == "Sold");
      setUsersTickets(filteredTickets);
    } else {
      console.error("Failed to fetch users tickets:", response.message);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: response.message,
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  useEffect(() => {
    fetchResaleTickets();
    if (location.state && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
      setLoading(false);
    }
  }, []);

  // Filter users based on the search query
  const filteredUsers = usersTickets.filter((tickets) => {
    const buyer_phone = `${tickets.buyer_phone}`.toLowerCase();
     const name = `${tickets.first_name? tickets.first_name +" "+tickets.last_name : "N/A"}`.toLowerCase();
    const buyer_name = `${tickets.buyer_first_name? tickets.buyer_first_name +" "+tickets.buyer_last_name : "N/A"}`.toLowerCase();
    const event = `${tickets.name}`.toLowerCase();

    const duration = `${tickets.duration} day`;
    const quantity = `${tickets.resale_quantity}`;

    const type = `${tickets.type}`.toLowerCase();
    const purchase_price = `${
      tickets.resale_quantity *
      (tickets.purchase_price /
        (Number(tickets.quantity) +
          Number(tickets.resold_quantity)))
    }`.toLowerCase();
    const date = new Date(tickets.purchase_date);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
    const purchase_date = `${formattedDate}`;

    const resale_price = `${Number(tickets.resale_price)}`.toLowerCase();

    const date1 = new Date(tickets.resale_date);
    const formattedDate1 = date1.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const formattedTime1 = date1.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
    const resale_date = `${formattedDate1}`;

    const resale_status = (tickets.resale_status=="Sold"?"Yes":"No").toLowerCase();

    const date2 = new Date(tickets.sold_date);
    const formattedDate2 = date2.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const formattedTime2 = date2.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
    const sold_date = tickets.resale_status=="Sold"?`${formattedDate2}`:"-";

    const payment_id = (tickets.resale_status=="Sold"?tickets.resale_payment_id:"-").toLowerCase();

    // const query = {fullName, email};
    // return query.includes(searchQuery.toLowerCase());
    const searchLower = searchQuery.toLowerCase();
  
    return name.includes(searchQuery) ||buyer_name.includes(searchQuery) ||quantity.includes(searchQuery) || resale_price.includes(searchQuery) || buyer_phone.includes(searchLower) || resale_date.includes(searchQuery) || resale_status.includes(searchLower) || sold_date.includes(searchQuery) ||event.includes(searchLower) || duration.includes(searchLower) || type.includes(searchLower) || purchase_price.includes(searchQuery)|| purchase_date.includes(searchQuery)|| payment_id.includes(searchQuery);
  });




  const columns = [
    {
        name: "Listed By Full Name",
        selector: (row) => `${row.first_name ? row.first_name +" "+row.last_name : "N/A"}`,
        sortable: true,
        width: "200px" 
    },
    {
        name: "Listed By Mobile Number",
        selector: (row) => `${row.phone}`,
        sortable: true,
        width: "200px" 
    },
    {
      name: "Full Name",
      selector: (row) => `${row.buyer_first_name ? row.buyer_first_name +" "+row.buyer_last_name : "N/A"}`,
      sortable: true,
      width: "200px" 
    },
    {
      name: "Mobile Number",
      selector: (row) => `${row.buyer_phone}`,
      sortable: true,
      width: "200px" 
    },
    {
      name: "Event",
      selector: (row) => `${row.name}`,
      sortable: true,
      width: "150px" 
    },
    {
        name: "Duration",
        selector: (row) => `${row.duration} day`,
        sortable: true,
        width: "200px" 
    },
    // {
    //   name: "Day",
    //   selector: (row) => {
    //     const startDate = new Date(row.start_datetime);
    //     const endDate = new Date(row.end_datetime);
    //     const diffInMs = endDate - startDate; // Difference in milliseconds
    //     const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // Convert to days
    //     return `${diffInDays+1}`;
    //   },
    //   sortable: true,
    // },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
    },
    {
      name: "No. of Tickets",
      selector: (row) => `${row.resale_quantity}`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Seat Number",
      selector: (row) => `${row.is_seats_required === "Yes" ? row.booked_seat : "-"}`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Purchase Price",
      selector: (row) =>  `${Number(row.resale_quantity) *(row.purchase_price /(Number(row.quantity) + Number(row.resold_quantity)))
    }`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Purchase Date",
      selector: (row) => {
        const date = new Date(row.purchase_date);
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${formattedDate}`;
      },
      sortable: true,
      width: "150px" 
    },
    {
      name: "Selling  Price",
      selector: (row) => Number(row.resale_price),
      sortable: true,
      width: "150px" 
    },
    {
      name: "Selling Date",
      selector: (row) => {
        const date = new Date(row.resale_date);
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${formattedDate}`;
      },
      sortable: true,
      width: "150px" 
    },
    {
      name: "Sold Out",
      selector: (row) => {
        return row.resale_status=="Sold"?"Yes":"No"
      },
      sortable: true,
      width: "120px" 
    },
    {
      name: "Sold Out Date",
      selector: (row) => {
        const date = new Date(row.sold_date);
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return row.resale_status=="Sold"?`${formattedDate}`:"-";
      },
      sortable: true,
      width: "150px" 
    },
    {
      name: "Payment Id",
      selector: (row) => {
        return row.resale_status=="Sold"?row.resale_payment_id:"-"
      },
      sortable: true,
      width: "150px" 
    },
    
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headCells: {
      style: {
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        paddingLeft: "8px", // Adjust padding
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
      },
    },
    pagination: {
      style: {
        fontSize: "16px",
      },
    },
  };

  const csvHeaders = [
    { label: "Listed By Mobile Number", key: "listed_by" },
    { label: "Mobile Number", key: "buyer_phone" },
    { label: "Event", key: "name" },
    { label: "Duration", key: "duration" },
    { label: "Type", key: "ticket_type" },
    { label: "No. of Tickets", key: "quantity" },
    { label: "Purchase Price", key: "purchase_price" },
    { label: "Purchase Date", key: "purchase_date" },
    { label: "Selling Price", key: "resale_price" },
    { label: "Resale Date", key: "resale_date" },
    { label: "Sold Out", key: "resale_status" },
    { label: "Sold Date", key: "sold_date" },
    { label: "Payment Id", key: "resale_payment_id" },
];


const csvData = filteredUsers.map((ticket) => {

  const formatDateTime = (date) => {
      if (!date) return "-";
      const d = new Date(date);
      return d.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
      });
    };

    return {
        listed_by: `${ticket.phone}`,
        buyer_phone: ticket.buyer_phone,
        name: ticket.name,
        duration: ticket.duration + " day",
        ticket_type: ticket.type,
        quantity: ticket.resale_quantity,
        purchase_price: (ticket.resale_quantity *(Number(ticket.purchase_price) /(Number(ticket.quantity) +Number(ticket.resold_quantity)))),
        purchase_date: formatDateTime(ticket.purchase_date),
        resale_price: Number(ticket.resale_price),
        resale_date: formatDateTime(ticket.resale_date),
        resale_status: ticket.resale_status === "Sold" ? "Yes" : "No",
        sold_date: ticket.resale_status === "Sold" ? formatDateTime(ticket.sold_date) : "-",
        resale_payment_id: ticket.resale_status === "Sold" ? ticket.resale_payment_id : "-",
    };
  });

  return (
    <Fragment>
      <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
        {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
        <h2 className='text-black font-w600 mb-0'>Sold Tickets</h2>
        {/* <CSVLink data={csvData} headers={csvHeaders} filename={"sold_tickets.csv"}>
                      <Button variant="primary">Download CSV</Button>
                  </CSVLink> */}
      </div>

      {/* Search input */}
      <div className='mb-4 d-sm-flex d-block justify-content-end'>
      <div style={{ position: "relative", width: "18rem" }}>
  <Form.Control
    type="text"
    placeholder="Search..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    style={{
      width: "100%",
      fontSize: "18px",
      fontWeight: 500,
      paddingRight: "2rem",
      borderRadius:'0.625rem',
      height:'3.2rem' // Add padding to ensure the icon doesn't overlap text
    }}
  />

  <i
    className="fa fa-search"
    style={{
      position: "absolute",
      right: "10px", // Distance from the right edge of the input
      top: "50%",
      transform: "translateY(-50%)", // Center vertically
      color: "#6c757d", // Optional: color for the icon
      pointerEvents: "none", // Makes sure clicks pass through to the input
    }}
  ></i>

</div>

      </div>

      <Card>
        <Card.Body>
          {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' />
                  <p>Loading settings...</p>
                </div>) : 
          (<DataTable
            columns={columns}
            data={filteredUsers} // Use filtered data
            customStyles={customStyles}
            pagination
            highlightOnHover
            responsive
          />)}
        </Card.Body>
      </Card>

    </Fragment>
  );
};

export default SoldTicket;
